import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { vcardMicrositeAPIService } from '~/api/microsites/vcard-plus';
import DEFAULT_VCARD_COVER_IMAGE from '~/assets/images/default-vcard-cover-image.webp';
import DEFAULT_VCARD_LOGO from '~/assets/images/default-vcard-logo.webp';
import { SOCIAL_ICON_ITEMS } from '~/constants/socials';
import { V_CARD_BUILDER_COLORS } from '~/constants/vCard';

export const updateVCardPlusSiteThunk = createAsyncThunk(
  'vCardPlusSlice/updateModelThunk',
  async (body, { rejectWithValue }) => {
    try {
      const response = await vcardMicrositeAPIService.updateVCardSite(body);
      if (body.dispatchHandler) {
        body.dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateVCardSocialThunk = createAsyncThunk(
  'vCardPlusSlice/updateVCardSocialThunk',
  async ({ body, id, type, dispatchHandler }, { rejectWithValue }) => {
    try {
      if (type === 'add') {
        await vcardMicrositeAPIService.createVCardSocial(body);
      } else if (type === 'update') {
        await vcardMicrositeAPIService.updateVCardSocial(body.data, body.id);
      } else if (type === 'delete') {
        await vcardMicrositeAPIService.deleteVCardSocial(body);
      }
      const response = await vcardMicrositeAPIService.getVCardSite(id);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
//phone
export const updateVCardPhoneThunk = createAsyncThunk(
  'vCardPlusSlice/updateVCardPhoneThunk',
  async ({ body, id, type, dispatchHandler }, { rejectWithValue }) => {
    try {
      if (type === 'add') {
        await vcardMicrositeAPIService.createVCardPhones(body);
      } else if (type === 'update') {
        await vcardMicrositeAPIService.updateVCardPhones(body.data, body.id);
      } else if (type === 'delete') {
        await vcardMicrositeAPIService.deleteVCardPhones(body);
      }
      const response = await vcardMicrositeAPIService.getVCardSite(id);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
//email
export const updateVCardEmailThunk = createAsyncThunk(
  'vCardPlusSlice/updateVCardEmailThunk',
  async ({ body, id, type, dispatchHandler }, { rejectWithValue }) => {
    try {
      if (type === 'add') {
        await vcardMicrositeAPIService.createVCardEmails(body);
      } else if (type === 'update') {
        await vcardMicrositeAPIService.updateVCardEmails(body.data, body.id);
      } else if (type === 'delete') {
        await vcardMicrositeAPIService.deleteVCardEmails(body);
      }
      const response = await vcardMicrositeAPIService.getVCardSite(id);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
//website
export const updateVCardWebsiteThunk = createAsyncThunk(
  'vCardPlusSlice/updateVCardWebsiteThunk',
  async ({ body, id, type, dispatchHandler }, { rejectWithValue }) => {
    try {
      if (type === 'add') {
        await vcardMicrositeAPIService.createVCardWebsite(body);
      } else if (type === 'update') {
        await vcardMicrositeAPIService.updateVCardWebsite(body.data, body.id);
      } else if (type === 'delete') {
        await vcardMicrositeAPIService.deleteVCardWebsite(body);
      }
      const response = await vcardMicrositeAPIService.getVCardSite(id);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
//company
export const updateVCardCompanyThunk = createAsyncThunk(
  'vCardPlusSlice/updateVCardCompanyThunk',
  async ({ body, id, type, dispatchHandler }, { rejectWithValue }) => {
    try {
      if (type === 'add') {
        await vcardMicrositeAPIService.createVCardCompany(body);
      } else if (type === 'update') {
        await vcardMicrositeAPIService.updateVCardCompany(body.data, body.id);
      } else if (type === 'delete') {
        await vcardMicrositeAPIService.deleteVCardCompany(body);
      }
      const response = await vcardMicrositeAPIService.getVCardSite(id);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
//location
export const updateVCardPlusLocationThunk = createAsyncThunk(
  'vCardPlusSlice/updateVCardPlusLocationThunk',
  async ({ body, id, dispatchHandler }, { rejectWithValue, getState }) => {
    try {
      const micrositeDataId = getState().vCardPlusReducer?.micrositeData?.id;
      await vcardMicrositeAPIService.updateVCardLocation(body, id);

      const response = await vcardMicrositeAPIService.getVCardSite(micrositeDataId);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
//person
export const updateVCardPlusPersonThunk = createAsyncThunk(
  'vCardPlusSlice/updateVCardPlusPersonThunk',
  async ({ body, id, dispatchHandler }, { rejectWithValue }) => {
    try {
      await vcardMicrositeAPIService.updateVCardPerson(body, id);

      const response = await vcardMicrositeAPIService.getVCardSite(id);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const vCardPlusSlice = createSlice({
  name: 'vCardPlusSlice',
  initialState: {
    loading: false,
    title: '',
    selectedTemplate: 0,
    bacgkroundColor: V_CARD_BUILDER_COLORS[0],
    fonts: {
      title: '',
      text: '',
    },
    basicInformation: {
      name: 'Name',
      surName: 'Surname',
      titleValue: 'Test title',
      titlePosition: 'center',
      logoImage: {
        url: DEFAULT_VCARD_LOGO,
        scale: 100,
        borderRadius: 50,
        rotate: 0,
      },
      coverImage: {
        url: DEFAULT_VCARD_COVER_IMAGE,
      },
      contactInfo: {
        phone: [
          {
            type: 'work',
            label: 'Phone',
            value: '+38099112200',
          },
        ],
        email: [
          {
            label: 'Email',
            value: 'example@gmail.com',
          },
        ],
        website: [
          {
            label: 'Website',
            value: 'https://example.com',
          },
        ],
      },
      location: {
        type: 'FULL',
        locationVisibility: 'HIDE_ADDRESS_LINK',
        address: '',
        streetNumberFirst: false,
        street: '',
        number: null,
        postalCode: '',
        city: '',
        state: '',
        country: '',
        url: 'https://expl.com',
        latitude: '49.933544',
        longitude: '7.629603',
      },
      summary:
        'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    content: {
      imagesType: 'VERTICAL',
      images: [],
      companies: [
        {
          id: 1,
          name: 'Company Test',
          profession: 'developer',
        },
      ],
      socialLinks: [
        { label: 'Instagram', value: 'https://www.instagram.com', title: '', network: SOCIAL_ICON_ITEMS[1].network },
        { label: 'Facebook', value: 'https://www.facebook.com', title: '', network: SOCIAL_ICON_ITEMS[3].network },
        { label: 'GitHub', value: 'https://github.com', title: '', network: SOCIAL_ICON_ITEMS[6].network },
      ],
      headerPhone: 'Phone',
      headerLocation: 'Geo',
      headerEmail: 'Email',
      footerTitle: 'Add contact',
      footerType: null,
      contactOptions: 'title only',
      socialTitle: 'Find me on:',
    },
    stats: {
      isAutogeneratedUrl: true,
      isLimitsEnabled: false,
      url: '',
      scan: '',
    },
    micrositeData: null,
    micrositeStyles: { container: {} },
    micrositeId: null,
    isDeleteSocialLoading: false,
  },
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    setSelectedTemplate(state, action) {
      state.selectedTemplate = action.payload;
    },
    setBackgroundColor(state, action) {
      state.bacgkroundColor = action.payload;
    },
    setFonts(state, action) {
      state.fonts[action.payload.field] = action.payload.value;
    },
    setBasicInformation(state, action) {
      state.basicInformation[action.payload.field] = action.payload.value;
    },
    setContactInfoItem(state, action) {
      state.basicInformation.contactInfo[action.payload.type] = action.payload.value;
    },
    setContactInfoField(state, action) {
      state.basicInformation.contactInfo[action.payload.name][action.payload.index][action.payload.field] =
        action.payload.value;
    },
    setLocationObject(state, action) {
      state.basicInformation.location = action.payload;
    },
    setLocationField(state, action) {
      state.basicInformation.location[action.payload.field] = action.payload.value;
    },
    setCompanies(state, action) {
      state.content.companies = action.payload;
    },
    setContentBaseField(state, action) {
      state.content[action.payload.field] = action.payload.value;
    },
    setCompaniesDetail(state, action) {
      state.content.companies[action.payload.index][action.payload.field] = action.payload.value;
    },
    setSocialLinks(state, action) {
      state.content.socialLinks = action.payload;
    },
    setImages(state, action) {
      state.content.images = action.payload;
    },
    setImagesType(state, action) {
      state.content.imagesType = action.payload;
    },
    setMicrositeData(state, action) {
      state.micrositeData = action.payload;
    },
    setStats(state, action) {
      state.stats[action.payload.field] = action.payload.value;
    },
    setStatsData(state, action) {
      state.stats = action.payload;
    },
    setNewCoverImage(state, action) {
      state.basicInformation.images[action.payload.index].previewLink = action.payload.url;
    },
    setContentLinkList(state, action) {
      state.content.linkList = action.payload;
    },
    setContentLinkListValues(state, action) {
      state.content.linkList[action.payload.index][action.payload.field] = action.payload.value;
    },
    setRenderedMicrositeData(state, action) {
      state.selectedTemplate = action.payload.selectedTemplate;
      state.bacgkroundColor = action.payload.bacgkroundColor;
      state.fonts = action.payload.fonts;
      state.basicInformation = action.payload.basicInformation;
      state.content = action.payload.content;
      state.micrositeData = action.payload.micrositeData;
      state.stats = action.payload.stats;
      state.micrositeId = action.payload.micrositeId;
    },
    setMicrositeStyles(state, action) {
      state.micrositeStyles = action.payload;
    },
    resetState: () => vCardPlusSlice.getInitialState(),
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateVCardPlusSiteThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardPlusSiteThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardPlusSiteThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //social
      .addCase(updateVCardSocialThunk.pending, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = true;
        }

        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardSocialThunk.fulfilled, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = false;
        }

        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardSocialThunk.rejected, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = false;
        }

        state.loading = false;
        state.error = action.payload;
      })
      //phone
      .addCase(updateVCardPhoneThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardPhoneThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardPhoneThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //email
      .addCase(updateVCardEmailThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardEmailThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardEmailThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //website
      .addCase(updateVCardWebsiteThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardWebsiteThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardWebsiteThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //company
      .addCase(updateVCardCompanyThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardCompanyThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardCompanyThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //location
      .addCase(updateVCardPlusLocationThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardPlusLocationThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardPlusLocationThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //person
      .addCase(updateVCardPlusPersonThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVCardPlusPersonThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateVCardPlusPersonThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default vCardPlusSlice.reducer;
